import React, { useEffect, useState } from "react";

type WPPost = {
  id: number;
  title: { rendered: string };
  excerpt: { rendered: string };
  link: string;
  date: string;
  _embedded?: {
    "wp:featuredmedia"?: Array<{ source_url: string }>;
  };
};

export const VideoSection = () => {
  const [posts, setPosts] = useState<WPPost[]>([]);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const res = await fetch(
          "https://konzortiacapital.com/blog/wp-json/wp/v2/posts?per_page=3&_embed"
        );
        const data: WPPost[] = await res.json();
        setPosts(data);
      } catch (err) {
        console.error("Failed fetching posts:", err);
      }
    }
    fetchPosts();
  }, []);

  return (
    <div className="bg-gray-100">
      <div className="px-4 pb-12 mx-auto container w-full">
        <div className="py-6">
          <span className="font-primary uppercase text-2xl md:text-3xl font-bold">
            Konzortia Capital Stories
          </span>
        </div>

        <div className="flex flex-col md:flex-row gap-6">
          {posts.map((post) => {
            const imageUrl =
              post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
              "/default-image.jpg";

            return (
              <div
                key={post.id}
                className="flex flex-col w-full md:w-1/3 rounded-lg overflow-hidden shadow-md"
              >
                {/* Image container with relative positioning */}
                <div className="relative w-full h-48">
                  <a href={post.link} target="_blank" rel="noopener noreferrer">
                    <img
                      src={imageUrl}
                      alt={post.title.rendered}
                      className="object-cover w-full h-full"
                    />
                  </a>

                  {/* Overlay on image */}
                  <div className="absolute bottom-0 left-0 w-full bg-white bg-opacity-30 flex justify-between items-center px-3 py-1">
                    <span className="text-xs text-gray-700">
                      {new Date(post.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </span>
                    <a
                      href={post.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 hover:text-gray-900"
                    >
                      <img src='/arrow-down-drop-circle-outline.svg' alt='konzortia' />
                    </a>
                  </div>
                </div>

                {/* Description below image */}
                <div className="p-2">
                  <span className="font-primary py-1 text-sm font-bold block">
                    <a
                      href={post.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {post.title.rendered}
                    </a>
                  </span>
                  <div
                    className="text-xs text-gray-600"
                    dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
